import { s as o } from "../index-CRFXyvqr.js";
import { devEnv as n, testEnv as s } from "../constant/index.js";
import i from "../constant/devKeysConfig.js";
import p from "../constant/proKeysConfig.js";
function c(e, t) {
  if (!e) return !1;
  const r = e["Content-Type"] || e["content-type"];
  return o(r, t);
}
function g(e, t, r) {
  return !r && (e = e || t == "pre" || t == "pro", sessionStorage.getItem("t_a_debug") == "debug" && (e = !1), e);
}
function y(e) {
  return e == n || e == s ? i() : p();
}
export {
  c as checkContentTypeHeader,
  g as getIsEncry,
  y as getKeys
};
